'use client'

import { createTheme } from '@mui/material/styles'
import { Colors } from './color'

export const theme = createTheme({
  typography: {
    fontFamily: ['"M PLUS 1p"', 'sans-serif'].join(','),
    h1: {
      fontSize: 18,
      fontWeight: 500,
    },
    h2: {
      fontSize: 16,
      fontWeight: 500,
    },
    h3: {
      fontSize: 14,
      fontWeight: 400,
    },
    body1: {
      fontSize: 14,
      fontWeight: 500,
    },
    body2: {
      fontSize: 13,
      fontWeight: 400,
    },
    button: {
      fontSize: 14,
      textTransform: 'none',
      fontWeight: 500,
    },
  },
  palette: {
    primary: {
      main: Colors.yellow,
    },
    secondary: {
      main: Colors.color0D0D0E,
    },
    text: {
      primary: Colors.colorD7D9DB,
      secondary: Colors.color5A5957,
    },
    error: {
      main: Colors.red,
    },
    background: {
      default: Colors.color121213,
      paper: Colors.color0D0D0E,
    },
    divider: Colors.color23221F,
  },
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          minHeight: '46px',
          '@media (max-width: 600px)': {
            fontSize: 16,
          },
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          minHeight: '46px',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            color: Colors.color91908F,
            backgroundColor: Colors.color5A5957,
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        icon: {
          color: Colors.color5A5957,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& fieldset': {
            borderColor: Colors.color91908F,
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiSvgIcon-root': {
            color: Colors.color5A5957,
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginTop: 0,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          paddingTop: '4px',
          paddingBottom: '4px',
          backgroundColor: Colors.color1A1A18,
          color: Colors.color5A5957,
          borderRadius: 7,
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          color: Colors.color5A5957,
          background: Colors.color1A1A18,
          '&.Mui-selected': {
            backgroundColor: Colors.color272727,
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: Colors.colorD7D9DB,
        },
      },
    },
    MuiBottomNavigationAction: {
      styleOverrides: {
        root: {
          color: Colors.color5A5957,
        },
      },
    },
  },
})
